import { auth } from "./firebase";

const NOTIFICATION_OPS_URL =
  process.env.REACT_APP_NOTIFICATION_OPS_URL ||
  "https://us-central1-petaar-3dcab.cloudfunctions.net/notificationOps";

export async function sendUserNotification(payload = {}) {
  const token = await auth.currentUser?.getIdToken?.();
  if (!token) {
    throw new Error("Session expired. Please login again.");
  }
  const response = await fetch(NOTIFICATION_OPS_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      action: "send",
      ...payload,
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data?.success) {
    throw new Error(data?.error || `Notification request failed (${response.status})`);
  }
  return data;
}
